<template>
  <div>
    <template v-if="app_status == 1">
      <div class="realnameCertification">
        <div class="realnameCertification-head">
          <div class="top-con">
            <div class="realnameCertification-head-title">
              实名认证
            </div>
            <div class="logo"></div>
          </div>
        </div>
        <div class="realnameCertification-card">
          <el-form ref="form" label-position="left" class="realnameCertification-card-form" label-width="321px" :model="form" :rules="rules">
            <el-form-item label="身份证照片" prop="frontIdPhoto" class="frontIdPhoto">
              <div class="lab-box">
                <div class="lab-box-mobile"><span>*</span>身份证照片</div>
                图片支持JPG,PNG,JPEG,大小不超过5M
              </div>
              <el-upload
                v-loading="loading"
                class="uploader"
                action
                :show-file-list="false"
                :auto-upload="false"
                :on-change="upload">
                <img v-if="!frontIdPhoto_url" src="@/assets/image/Contract/IDCard1.png" class="uploader-img">
                <img v-else-if="frontIdPhoto_url" :src="frontIdPhoto_url" class="uploader-img">
                <div class="uploader-tip">{{ !frontIdPhoto_url?'点击上传身份证人像面':'人像面' }}</div>
              </el-upload>
            </el-form-item>
            <el-form-item label="" prop="backIdPhoto" class="backIdPhoto">
              <el-upload
                v-loading="loadingback"
                class="uploader"
                action
                :show-file-list="false"
                :auto-upload="false"
                :on-change="uploadCardBehind">
                <img v-if="!backIdPhoto_url" src="@/assets/image/Contract/IDCard2.png" class="uploader-img">
                <img v-else-if="backIdPhoto_url" :src="backIdPhoto_url" class="uploader-img">
                <div class="uploader-tip">{{ !backIdPhoto_url?'点击上传身份证国徽面':'国徽面' }}</div>
              </el-upload>
            </el-form-item>
            <el-form-item v-if="frontIdPhoto_url != '' && backIdPhoto_url != ''" label="姓名" prop="name" class="form-name">
              <div class="form-name-labelMobile">
                姓名
              </div>
              <el-input v-model="form.name" :disabled="!editName" @blur="editName = false">
                <template slot="append">
                  <i class="el-icon-edit" @click="editName = !editName"></i>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item v-if="frontIdPhoto_url != '' && backIdPhoto_url != ''" label="身份证号" prop="card_id" class="form-card_id">
              <div class="form-name-labelMobile">
                身份证号
              </div>
              <el-input v-model="form.card_id" :disabled="!editCardId" @blur="editCardId = false">
                <template slot="append">
                  <i class="el-icon-edit" @click="editCardId = !editCardId"></i>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item class="form-btnGroup">
              <button class="form-btnGroup-back" v-prevent-re-click @click="resetForm()">返回</button>
              <button class="form-btnGroup-submit" v-prevent-re-click type="primary" @click="save()">提交</button>
            </el-form-item>
          </el-form>
        </div>

        <!-- <div class="realnameCertification-foot">
          <img src="@/assets/image/Contract/fddTip.png"/>
          本平台电子合同由法大大提供技术支持
        </div> -->
      </div>
    </template>
    <template v-else>
      <div class="realnameCertificationMobile">
        <div class="realnameCertificationMobile-head">
          <div>实名认证</div>
          <div class="logo"></div>
        </div>
        <div class="realnameCertificationMobile-body">
          <div class="realnameCertificationMobile-body-card">
            <el-form ref="form" label-position="left" class="realnameCertificationMobile-body-card-form" :model="form" :rules="rules">
              <el-form-item label="身份证照片" prop="frontIdPhoto" class="frontIdPhoto">
                <el-upload
                  v-loading="loading"
                  class="uploader"
                  action
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-change="upload">
                  <img v-if="!frontIdPhoto_url" src="@/assets/image/Contract/IDCard1.png" class="uploader-img">
                  <img v-else-if="frontIdPhoto_url" :src="frontIdPhoto_url" class="uploader-img">
                  <div class="uploader-tip">{{ !frontIdPhoto_url?'点击上传身份证人像面':'人像面' }}</div>
                </el-upload>
              </el-form-item>
              <el-form-item label="" prop="backIdPhoto" class="backIdPhoto">
                <el-upload
                  v-loading="loadingback"
                  class="uploader"
                  action
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-change="uploadCardBehind">
                  <img v-if="!backIdPhoto_url" src="@/assets/image/Contract/IDCard2.png" class="uploader-img">
                  <img v-else-if="backIdPhoto_url" :src="backIdPhoto_url" class="uploader-img">
                  <div class="uploader-tip">{{ !backIdPhoto_url?'点击上传身份证国徽面':'国徽面' }}</div>
                </el-upload>
              </el-form-item>
              <el-form-item v-if="frontIdPhoto_url != '' && backIdPhoto_url != ''"  prop="name" class="form-name">
                <div class="form-name-labelMobile">
                  姓名
                </div>
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item v-if="frontIdPhoto_url != '' && backIdPhoto_url != ''"  prop="card_id" class="form-card_id">
                <div class="form-name-labelMobile">
                  身份证号
                </div>
                <el-input v-model="form.card_id"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="realnameCertificationMobile-foot">
          <button class="realnameCertificationMobile-foot-resBtn" v-prevent-re-click @click="resetForm">
            返回
          </button>
          <button class="realnameCertificationMobile-foot-subBtn" v-prevent-re-click @click="save">
            提交
          </button>
        </div>
      </div>
    </template>
    <myDialog :closeOnOther="false" :text="'未满18周岁不允许交易，点击按钮重新添加签约人信息'"  :show="faceIndeShow" :close-fun="() => {faceIndeShow = false}">
      <div slot="btn" class="myDialog-btn" @click="faceIndeShow = false,resetForm(),$emit('underageChange')">
        重填
      </div>
    </myDialog>
  </div>
</template>

<script>
import {
  apiSellCard,
  appUploadAuthCardBehind,
  appAliyunAuth,
  apiContractsellerInfoVerified
  } from "../../request/API";
import * as imageConversion from 'image-conversion'
import myDialog from "@/components/myDialog";
/**
 * 表单验证失败时 滚动到第一个error位置
 */
const scrollIntoView = (className = "is-error", block = "center") => {
    Promise.resolve().then(() => {
       const target = document.getElementsByClassName(className);
     if (target.length) {
        target[0].scrollIntoView({
           behavior: "smooth",
           block: block,
       });
    }
  });
};
export default {
  name: 'realnameCertification',
  components: {myDialog},
  props:{
    app_status: {
      type: [String, Number],
      default() {
        return 1
      }
    },
  },
  data() {
    return {
      faceIndeShow: false,
      loading: false,
      loadingback: false,
      fuck_loading: true,
      form: {
        name: '',
        card_id: '',
        frontIdPhoto: '',
        backIdPhoto: '',
      },
      frontIdPhoto_url: '',
      backIdPhoto_url: '',
      rules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
          { max: 30, message: '姓名不得超过30个汉字', trigger: 'blur' }
        ],
        card_id: [
          {required: true, message: '请输入身份证号', trigger: 'blur'},
          { validator: this.validate, trigger: ['change','blur'] }
        ],
        frontIdPhoto: [
          {required: true, message: '请上传身份证人像面照片', trigger: 'change'},
        ],
        backIdPhoto: [
          {required: true, message: '请上传身份证国徽面照片', trigger: 'change'},
        ],
      },

      //编辑姓名
      editName:false,
      //编辑身份证号
      editCardId:false,
    }
  },
  created() { },
  methods: {
    faceIndeShowClose() {
      this.$router.push({
        path: '/login',
        query: {
          Rurl: this.$route.fullPath
        },
      })
    },
    resetForm() {
      this.$emit('step')
    },
    save() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          apiContractsellerInfoVerified(this.app_status,{
            cert_name: this.form.name,
            cert_id: this.form.card_id
          }).then(res => {
            this.$emit('realNameSubmit',this.form)
            this.$emit('step')
          }).catch(e => {
            if (e.code == 10008) {
              this.faceIndeShow = true //未成年提示
            } else {
              this.$message({
                message: e.msg,
                center: true,
                offset: 200,
                customClass: 'sell-contract-msg'
              })
            }
          })
        }else{
        }
      })
    },
    validate (rule, value, callback) {
      let reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (reg.test(value)) {
        callback()
      } else {
        callback(new Error('身份证号码格式错误!'));
      }
    },
    /**
     * @description: 生成唯一标识
     * @return {*}
     */
    uuid() {
        let s = [];
        let hexDigits = "0123456789abcdef";
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";
        let uuid = s.join("");
        return uuid;
    },
    async upload(file) {
      this.loading = true
      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message({
          message: '上传图片只能是 JPG/PNG 格式!',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
        return
      }
      let newFile = await imageConversion.compressAccurately(file.raw, {
        size: 900,
        type: 'image/jpeg'
      })
      let blob_file = new File([newFile],this.uuid()+".jpeg",{type:file.type,lastModified: Date.now()})
      let formData = new FormData()
      formData.append('file', blob_file)
      apiSellCard(this.app_status,formData).then(resp => {
        appAliyunAuth(this.app_status,{
          url: resp.data.url
        }).then(res => {
          // if(this.form.card_id!=''&&this.form.card_id!=null&&this.form.card_id!=res.data.cert_id){
          //   this.$message({
          //     message: '上传身份证与法大大实名不一致',
          //     center: true,
          //     offset: 200,
          //     customClass: 'sell-contract-msg'
          //   })
          //   this.loading = false
          //   this.frontIdPhoto_url = ''
          //   return
          // } else {
            this.form.frontIdPhoto = resp.data.uri
            this.frontIdPhoto_url = resp.data.url
            this.form.name = res.data.cert_name
            this.form.card_id = res.data.cert_id
            if(this.form.name == '' || this.form.card_id == ''){
              this.frontIdPhoto_url = ''
              this.$message({
                message: '验证失败，请重新上传',
                center: true,
                offset: 200,
                customClass: 'sell-contract-msg'
              })
            } else {
              this.$message({
                message: '验证通过',
                center: true,
                offset: 200,
                customClass: 'sell-contract-msg'
              })
            }
            this.loading = false
          // }
        }).catch(err => {
          this.$message({
            message: err.msg,
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
          this.loading = false
        })
      }).catch(err => {
        this.$message({
          message: err.msg,
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
        this.loading = false
      })
    },
    async uploadCardBehind(file) {
      this.loadingback = true
      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message({
          message: '上传图片只能是 JPG/PNG 格式!',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
        return
      }
      let newFile = await imageConversion.compressAccurately(file.raw, {
        size: 900,
        type: 'image/jpeg'
      })
      let blob_file = new File([newFile],this.uuid()+".jpeg",{type:file.type,lastModified: Date.now()})
      this.$getBase64(newFile).then(res => {
        appUploadAuthCardBehind(this.app_status,{
          file:res
        }).then(res=>{
          let formData = new FormData()
          formData.append('file', blob_file)
          apiSellCard(this.app_status,formData).then(resp => {
            this.form.backIdPhoto = resp.data.uri
            this.backIdPhoto_url = resp.data.url
            this.$message({
              message: '验证通过',
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
            this.loadingback = false
          }).catch(err => {
            this.$message({
              message: err.msg,
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
            this.loadingback = false
          })
        }).catch(err=>{
          this.$message({
            message: err.msg,
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
          this.loadingback = false
        })
      });
    },
  }
}
</script>

<style lang="less">
@import "./styles/contractFeedback.less";
</style>

<style lang="less" scoped>
.myDialog-btn{
  width: 250px;
  height: 40px;
  line-height: 40px;
  border-radius: 4px 4px 4px 4px;
  text-align: center;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  background: #FFDB51;
  color: #000000;
  cursor: pointer;
}
.seller-contract {
  background-color: #f9fafb;
  -webkit-tap-highlight-color:rgba(0,0,0,0);
  .payeeTipDia{
    border-radius: 4px;
    width: 386px;
    .el-dialog__header{
      font-size: 20px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
    }
    .el-dialog__body{
      padding: 0 24px 24px;
      .payee-content{
        border-top: 1px solid #F3F3F3;
        p{
          margin: 10px 0 0;
          position: relative;
          padding-left: 14px;
          // display: flex;
          // justify-content: flex-start;
          // align-items: flex-start;
          &::before{
            content: ' ';
            display: inline-block;
            width: 6px;
            height: 16px;
            background: #FCAD13;
            position: absolute;
            top: 2px;
            left: 0px;
            // margin-left: -10px;
            // margin-right: 4px;
          }
        }
      }
    }
  }
  .seller-top {
    height: 278px;
    width: 100vw;
    background-color: #D8D2CA;
    .top-con{
      width: 1200px;
      // margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }
    .container {
      padding-top: 63px;
      padding-left: 20px;

      img {
        width: 224px;
        height: 30px;
      }

      span {
        display: block;
        margin-top: 13px;
        font-size: 32px;
        color: #fff;
      }
    }
    .logo{
      margin-top: 63px;
      background: url('../../assets/image/Contract/logo.png') no-repeat;
      background-size: 100%;
      width: 250px;
      height: 58px;
      margin-right: 20px;
    }
  }

  //  /deep/ .seller-contract .seller-main .form{
  //   margin: 0;
  // }
  .seller-main {
    position: relative;
    top: -123px;
    width: 1200px;
    padding: 0 98px;
    // margin: 0 auto;
    padding-bottom: 57px;
    background-color: #FFFFFF;
    border-radius: 4px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.10);
    .form {
      max-width: 400px;
      margin: 0;
      padding-top: 30px;
      .contract_order_sn{
        background: #eef3ff;
        border-radius: 4px;
        margin: 39px 0 32px;
        padding: 13px 17px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #5A5F6B;
      }
      .fdd-tip{
        height: 33px;
        background: #f0f4ff;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: #5A5F6B;
        img{
          width: 20px;
          height: 12px;
          margin-right: 5px;
        }
      }
      .el-form-item {
        margin-left: 98px;
        margin-bottom: 20px;
        .el-form-item__label {
          display: inline;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: bold;
          text-align: LEFT;
          color: #5b5b5b;
          display: flex;
          justify-content: flex-start;
          .item-label{
            flex: 1;
            display: flex;
            justify-content: space-between;
            i{
              font-style: normal;
              &.item-radio{
                font-size: 16px;
                color: #5A5F6B;
              }
            }
          }
          .payee-tip{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            img{
              width: 17px;
              height: 17px;
              margin-left: 6px;
            }
          }
        }

        .el-form-item__error {
          right: 0;
          left: auto;

          &::before {
            position: absolute;
            content: ' ';
            left: -16px;
            top: 3.5px;
            width: 13px;
            height: 13px;
            background-image: url("../../assets/image/Contract/err.png");
            background-size: 100%;
          }
        }

        .el-input-group__append{
          width: 3rem;
        }
      }
      .contract_radio{
        .el-form-item__content{
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          margin-top: 14px;
          &::before,&::after{
            display: none;
          }
        }
        .el-radio{
          margin: 0;
        }
        .el-radio__input{
          display: none;
        }
        .el-radio__input.is-checked+.el-radio__label{
          color: #FF8A00;
          background: #feedcb;
        }
        .el-radio__label{
          display: inline-block;
          width: 168px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: #f7f8f9;
          border-radius: 4px;
          margin-bottom: 10px;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #393939;
          padding: 0;
        }
      }
      .form-item-id-card {
        .el-form-item__error {
          left: 40%;
        }
      }

      .point {
        padding: 9px 20px;
        margin-top: 5px;
        line-height: 16px;
        background: #fff0f0;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Light;
        color: #5b5b5b;

        span {
          color: #FF750C;
        }
      }
      .lab-box{
        width: 291px;
        height: 20px;
        font-size: 14px;
        font-family: PingFang SC-Regular;
        color: #666666;
      }
    .id-card-box{
      margin-top: 31px;
      width: 195px;
      height: 105px;
      padding: 20px 74px 48px 74px;
      border: 2px dashed #DFE4ED ;
      .btn-up{
        width: 120px;
        height: 17px;
        font-size: 12px;
        color: #CECECE;
        line-height: 14px;
        margin: 14px 38px 17px 37px;
        font-family: PingFang SC-Regular;
      }
    }
      .id-card {
        position: relative;
        cursor: pointer;
        margin: 10px auto;
        width: 195px;
        height: 105px;
        background-image: url("../../assets/image/Contract/IDCard1.jpg");
        background-size: 100%;
        .el-upload{
          width: 195px;
          height: 105px;
        }
        .img-box {
          position: relative;
          width: 100%;
          height: 100%;

          img {
            width: 100%;
            height: 100%;
          }

          .mask {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.50);
            display: flex;
            justify-content: center;
            align-items: center;

            span {
              display: inline-block;
              width: 70px;
              height: 26px;
              line-height: 26px;
              font-size: 12px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              text-align: center;
              color: #ffffff;
              border: 1px solid #ffffff;
              border-radius: 4px;
            }
          }
        }

        input[type="file"] {
          position: absolute;
          top: 0;
          z-index: 2;
          cursor: pointer;
          width: 100%;
          height: 100%;
          opacity: 0;
        }
      }
      .id-card-back{
        background-image: url("../../assets/image/Contract/IDCard1.png");
        background-size: 100%;
      }
    }

    .seller-btn {
      width: 80%;
      margin: 0 auto;
      margin-top: 60px;
      display: flex;
      justify-content: center;

      button {
        width: 250px;
        height: 50px;
        border-radius: 4px;
        font-size: 18px;
        font-weight: 500;
        display: inline-block;
        text-align: center;
      }

      .reset {
        border: 1px #000 solid
      }

      .sub {
        border: 1px #FFDB51 solid;
        background-color: #FFDB51;
        color: #000;
        margin-left: 30px;
      }
    }
  }

  @media screen and (max-width: 1300px) {
    .seller-top{
      .top-con{
        width: 95vw;
      }
    }
    .seller-main {
      width: 95vw;
    }
  }
  @media screen and (max-width: 900px) {
    .seller-top {
      height: 140px;
      .top-con{
        display: flex;
        justify-content: center;
        position: relative;
      }

      .container {
        // margin: 0 auto;
        text-align: center;
        padding-top: 23px;
        img {
          width: 130px;
          height: 18px;
        }
        span{
          margin-top: 7px;
          font-size: 14px;
        }
      }
      .logo{
        position: absolute;
        padding: 0;
        top: 110px;
        z-index: 1;
        background: url('../../assets/image/Contract/logo-m.png') no-repeat;
        background-size: 100%;
        width: 139px;
        height: 33px;
        margin: 0;
      }
    }
    .seller-main {
      top: -53px;
      padding-top: 67px;
      .form{
        .contract_order_sn{
          margin-top: 0;
        }
      }
    }
  }
  @media screen and (max-width: 500px) {
    .seller-main {
      width: 93vw;
      .form {
        width: 80vw;
        padding-top: 10px;
        .el-form-item{
          .el-form-item__label{
            font-size: 14px;
          }
        }
        .contract_radio{
          .el-radio__label{
            width: 136px;
            font-size: 14px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 380px) {
    .payeeTipDia{
      width: 85vw;
    }
    .seller-main {
      .form {
        .contract_radio{
          .el-radio__label{
            width: 123px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 500px) {
  .el-message-box{
    width: 90vw !important;
  }
}
</style>

<style lang="less" scoped>
.realnameCertification{
  width: 100vw;
  min-height: 100vh;
  background: linear-gradient(to bottom,
  #D8D2CA 0%,
  #D8D2CA 278px,
  #F9FAFB 278px,
  #F9FAFB 100%);

  &-head {
    width: 1160px;
    height: 199px;
    padding: 0 16px 0 24px;
    margin: 0 auto;
    &-title{
      font-size: 32px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      margin: 0 0 0 24px;
      line-height: 199px;
    }

  }

  &-card {
    width: 1200px;
    height: 773px;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px 4px 4px 4px;
    margin: 0 auto;

    &-form{
      padding:80px 0 0 84px;
      .frontIdPhoto,.backIdPhoto{
        .lab-box{
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          margin: 0 0 20px;
          display: flex;
          align-items: center;
          .lab-box-mobile{
            display: none;
            font-size: 14px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            span{
              font-size: 14px;
              font-family: PingFang SC-Light, PingFang SC;
              font-weight: 300;
              color: #FF0E0E;
              margin: 0 6px 0 0;
            }
          }
        }
        .id-card-box{
          width: 343px;
          height: 173px;
          border-radius: 4px;
          border:2px dotted #DFE4ED;
          display: flex;
          flex-direction: column;
          align-items: center;
          //justify-content: center;

          .id-card {
            position: relative;
            cursor: pointer;
            margin: 20px auto 14px;
            width: 195px;
            height: 105px;
            background-image: url("../../assets/image/Contract/IDCard1.jpg");
            background-size: 100%;
            .el-upload{
              width: 195px;
              height: 105px;
            }
            .img-box {
              position: relative;
              width: 100%;
              height: 100%;

              img {
                width: 100%;
                height: 100%;
              }

              .mask {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 2;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.50);
                display: flex;
                justify-content: center;
                align-items: center;

                span {
                  display: inline-block;
                  width: 70px;
                  height: 26px;
                  line-height: 26px;
                  font-size: 12px;
                  font-family: PingFang SC, PingFang SC-Regular;
                  font-weight: 400;
                  text-align: center;
                  color: #ffffff;
                  border: 1px solid #ffffff;
                  border-radius: 4px;
                }
              }
            }

            input[type="file"] {
              position: absolute;
              top: 0;
              z-index: 2;
              cursor: pointer;
              width: 100%;
              height: 100%;
              opacity: 0;
            }
          }
          .id-card-back{
            background-image: url("../../assets/image/Contract/IDCard1.png");
            background-size: 100%;
          }

          .btn-up{
            height: 17px;
            line-height: 17px;
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #CECECE;
            text-align: center;
          }
        }

        .uploader,/deep/.el-upload {
          width: 343px;
          height: 173px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .uploader{
          border-radius: 4px;
          border:2px dotted #DFE4ED;
          &-img{
            width: 195px;
            height: 105px;
            margin: 0 0 14px;
          }
          &-tip{
            height: 17px;
            line-height: 17px;
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #CECECE;
            text-align: center;
          }
        }
      }

      .form-name,.form-card_id{
        /deep/.el-input{
          width: 407px;
          .el-input__inner,.el-input-group__append{
            border:none;
            border-bottom: 1px solid #DEE3EC;
            background:none;
            padding-right: 0;
          }
        }
        &-labelMobile{
          display: none;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #676767;
        }
      }

      .form-btnGroup{
        display: flex;
        align-items: center;
        margin: 60px 0 0;
        transform: translateX(-66px);
        /deep/.el-form-item__content{
          margin: 0 0 0 247px;
        }
        button{
          width: 250px;
          height: 50px;
          line-height: 50px;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #333333;
          font-size: 18px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          background: #FFFFFF;
        }
        &-submit{
          background: #FFDB51 !important;
          border: 1px solid #FFDB51 !important;
          margin: 0 0 0 30px;
        }

      }
    }
  }

  &-foot{
    height: 33px;
    background: #F0F4FF;
    display: none;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #5A5F6B;
    img{
      width: 20px;
      height: 11.76px;
      margin: 0 5px 0 0;
    }
  }

  @media screen and (max-width: 1300px) {
    &-head {
      width: 100%;
      margin: 0 auto;
      padding:0;
      &-title{
        margin: 0;
        text-align: center;
        line-height: 199px;
      }
    }
    &-card {
      width: calc(100% - 22px * 2);
      margin:0 22px;
      &-form{
        padding:80px 0 0 84px;
        .frontIdPhoto,.backIdPhoto{
          .lab-box{
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            margin: 0 0 20px;
          }
          .id-card-box{
            width: 343px;
            height: 173px;
            border-radius: 4px;
            border:2px dotted #DFE4ED;
            display: flex;
            flex-direction: column;
            align-items: center;
            //justify-content: center;

            .id-card {
              position: relative;
              cursor: pointer;
              margin: 20px auto 14px;
              width: 195px;
              height: 105px;
              background-image: url("../../assets/image/Contract/IDCard1.jpg");
              background-size: 100%;
              .el-upload{
                width: 195px;
                height: 105px;
              }
              .img-box {
                position: relative;
                width: 100%;
                height: 100%;

                img {
                  width: 100%;
                  height: 100%;
                }

                .mask {
                  position: absolute;
                  top: 0;
                  left: 0;
                  z-index: 2;
                  width: 100%;
                  height: 100%;
                  background: rgba(0, 0, 0, 0.50);
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  span {
                    display: inline-block;
                    width: 70px;
                    height: 26px;
                    line-height: 26px;
                    font-size: 12px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    text-align: center;
                    color: #ffffff;
                    border: 1px solid #ffffff;
                    border-radius: 4px;
                  }
                }
              }

              input[type="file"] {
                position: absolute;
                top: 0;
                z-index: 2;
                cursor: pointer;
                width: 100%;
                height: 100%;
                opacity: 0;
              }
            }
            .id-card-back{
              background-image: url("../../assets/image/Contract/IDCard1.png");
              background-size: 100%;
            }

            .btn-up{
              height: 17px;
              line-height: 17px;
              font-size: 12px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #CECECE;
              text-align: center;
            }
          }

          .uploader,/deep/.el-upload {
            width: 343px;
            height: 173px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }
          .uploader{
            border-radius: 4px;
            border:2px dotted #DFE4ED;
            &-img{
              width: 195px;
              height: 105px;
              margin: 0 0 14px;
            }
            &-tip{
              height: 17px;
              line-height: 17px;
              font-size: 12px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #CECECE;
              text-align: center;
            }
          }
        }

        .form-name,.form-card_id{
          /deep/.el-input{
            width: 407px;
            .el-input__inner,.el-input-group__append{
              border:none;
              border-bottom: 1px solid #DEE3EC;
              background:none;
            }
          }
        }

        .form-btnGroup{
          display: flex;
          align-items: center;
          margin: 60px 0 0;
          transform: translateX(-20px);
          /deep/.el-form-item__content{
            margin: 0 0 0 247px !important;
          }
          button{
            width: 250px;
            height: 50px;
            line-height: 50px;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #333333;
            font-size: 18px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #FFFFFF;
          }
          &-submit{
            background: #FFDB51 !important;
            border: 1px solid #FFDB51 !important;
            margin: 0 0 0 30px;
          }

        }
      }
    }
  }
  @media screen and (max-width: 900px) {

    padding: 0 0 50px;
    position: relative;

    /deep/.el-form-item__label{
      display: none;
    }
    /deep/.el-form-item__content{
      margin-left: 0px !important;
    }

    &-head {
      height: 78px;
      &-title{
        line-height: 78px;
      }
    }
    &-card {
      height: auto;
      &-form{
        padding:20px 12px;
        .frontIdPhoto,.backIdPhoto{
          .lab-box{
            justify-content: center;
            font-size: 12px;
            font-family: PingFang SC-Light, PingFang SC;
            font-weight: 300;
            color: #A2A2A2;
            margin: 0 0 11px;
            .lab-box-mobile{
              display: inline-block;
              margin: 0 10px 0 0;
            }
          }
          .uploader,/deep/.el-upload {
            //width: 325px;
            width: calc(100% - 14px * 2);
            max-width: 325px;
            height: 173px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }
          .uploader{
            border-radius: 4px;
            border:2px dotted #DFE4ED;
            margin:  0 auto;
            &-img{
              width: 195px;
              height: 105px;
              margin: 0 0 14px;
            }
            &-tip{
              height: 17px;
              line-height: 17px;
              font-size: 12px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #CECECE;
              text-align: center;
            }
          }
        }

        .form-name,.form-card_id{
          /deep/.el-form-item__content{
            max-width: 407px;
            width: calc(100% - 14px * 2);
            display: flex;
            align-items: center;
            border-bottom: 1px solid #DEE3EC;
          }
          display: flex;
          align-items: center;
          justify-content: center;
          /deep/.el-input{
            width: auto;
            //max-width: 407px;
            //width: calc(100% - 14px * 2);
            .el-input__inner,.el-input-group__append{
              border:none;
              background:none;
            }
          }
          &-labelMobile{
            width: 56px;
            display: inline-block;
          }

        }

        .form-btnGroup{
          justify-content: center;
          transform: translateX(0px);
          /deep/.el-form-item__content{
            margin: 0 !important;
            display: flex;
            justify-content: center;
          }
          button{
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            background: #FFFFFF;
            width: 150px;
          }
          &-submit{
            margin: 0 0 0 20px;
          }

        }
      }
    }

    &-foot{
      display: flex;
      position: absolute;
      width: 100%;
      bottom: 0;
    }
  }

  @media screen and (max-width: 500px) {

  }
}

</style>

<style lang="less" scoped>
.realnameCertification {
  width: 100vw;
  min-height: 100vh;
  background: var(--bg-page, #F7F5F2);

  &-head {
    width: 100vw;
    height: 278px;
    padding: 0;
    background: #D8D2CA;

    .top-con {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }

    &-title {
      box-sizing: border-box;
      padding: 63px 20px 0;
      line-height: 30px;
      font-size: 24px;
      font-weight: 600;
      color: #FFFFFF;
    }

    .logo {
      margin-top: 72px;
      width: 250px;
      height: 58px;
      box-sizing: border-box;
      padding: 8px 18px;
      border-radius: 4px;
      background-color: var(--bg-card, #FFFFFF);
      background-image: url("~@/assets/logo/logo_horizontal.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-size: calc(100% - 36px) calc(100% - 16px);
      margin-right: 20px;
    }
  }

  &-card {
    position: relative;
    top: -123px;
    width: 1200px;
    min-height: 560px;
    height: auto;
    margin: 0 auto;
    background: var(--bg-card, #FFFFFF);
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.10);

    &-form {
      box-sizing: border-box;
      padding: 80px 84px 57px;

      .frontIdPhoto,
      .backIdPhoto {
        .uploader {
          border-color: var(--border-soft, #E8E4DE);
          background: var(--bg-section, #F7F5F2);
        }

        .uploader-tip,
        .lab-box {
          color: var(--text-secondary, #5A5F6B);
        }
      }

      .form-name,
      .form-card_id {
        /deep/ .el-input {
          .el-input__inner,
          .el-input-group__append {
            border-bottom-color: var(--border-soft, #E8E4DE);
          }
        }
      }

      .form-btnGroup {
        width: 80%;
        margin: 60px auto 0;
        transform: none;
        display: flex;
        align-items: center;
        justify-content: center;

        /deep/ .el-form-item__content {
          margin: 0 !important;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        button {
          width: 250px;
          height: 50px;
          box-sizing: border-box;
          padding: 0;
          line-height: 1;
          border-radius: 3px;
          font-family: inherit;
          font-size: 18px;
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          cursor: pointer;
          transition: all .2s ease;
          color: var(--text-main, #1A1D24);
          border: 1.5px solid var(--bg-dark, #1A1D24) !important;
          background: transparent !important;

          &:hover,
          &:focus {
            color: var(--text-main, #1A1D24);
            border-color: var(--bg-dark, #1A1D24) !important;
            background: var(--bg-tag, #F0EDE8) !important;
          }

          &:active {
            border-color: var(--bg-dark, #1A1D24) !important;
            background: var(--bg-tag, #F0EDE8) !important;
          }

          &:disabled {
            cursor: not-allowed;
            opacity: .68;
          }
        }

        .form-btnGroup-submit {
          margin-left: 30px;
        }

        &-submit {
          color: #FFFFFF;
          border: 0 !important;
          background: var(--primary, #FF5A1F) !important;
        }

        button.form-btnGroup-submit {
          color: #FFFFFF;
          border-radius: 3px;
          border: 0 !important;
          background: var(--primary, #FF5A1F) !important;

          &:hover,
          &:focus {
            color: #FFFFFF;
            border: 0 !important;
            background: var(--primary-hover, #E84A12) !important;
          }

          &:active {
            color: #FFFFFF;
            background: var(--primary-hover, #E84A12) !important;
          }

          &:disabled {
            color: rgba(255, 255, 255, 0.75);
            border: 0 !important;
            background: var(--primary, #FF5A1F) !important;
            box-shadow: none;
            opacity: .68;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1300px) {
    &-head {
      .top-con {
        width: 95vw;
      }
    }

    &-card {
      width: 95vw;
    }
  }

  @media screen and (max-width: 900px) {
    padding-bottom: 40px;

    &-head {
      height: 140px;

      .top-con {
        display: flex;
        justify-content: center;
        position: relative;
      }

      &-title {
        width: 93vw;
        padding-top: 23px;
        text-align: center;
        line-height: 24px;
        font-size: 20px;
      }

      .logo {
        position: absolute;
        top: 110px;
        z-index: 1;
        width: 139px;
        height: 33px;
        box-sizing: border-box;
        padding: 4px 10px;
        border-radius: 4px;
        background-color: var(--bg-card, #FFFFFF);
        background-image: url("~@/assets/logo/logo_horizontal.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: calc(100% - 20px) calc(100% - 8px);
        margin: 0;
      }
    }

    &-card {
      top: -53px;
      width: 93vw;
      min-height: auto;

      &-form {
        padding: 24px 12px 28px;

        .form-btnGroup {
          margin-top: 40px;

          button {
            width: 140px;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
          }

          .form-btnGroup-submit {
            margin-left: 20px;
          }
        }
      }
    }
  }
}

.realnameCertificationMobile {
  background-image: url("../../assets/image/Contract/sellerInformationMobile/headBG.png");
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: #f6f6f6;
  width: 100vw;
  min-height: calc(100vh - 80px);
  padding-bottom: 80px;
  &-head{
    height: 51px;
    padding-top: 49px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
  }
  &-body{
    padding: 0 11px;
    &-card{
      padding:40px 14px 28px;
      background: #FFFFFF;
      border-radius: 4px 4px 4px 4px;
      &-form{
        .frontIdPhoto{
          /deep/.el-form-item__label{
            margin: 0 0 20px;
            line-height: 16px;
          }
        }
        .uploader{
          /deep/.el-upload{
            width: calc(100% - 2px * 2);
            padding: 20px 0 17px;
            border: 2px dashed #DFE4ED;
            border-radius: 4px;
            .uploader-img{
              width: 195px;
              height: 105px;
            }
            .uploader-tip{
              font-size: 12px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #CECECE;
              line-height: 14px;
            }
          }

        }

        .form-name,.form-card_id{
          /deep/.el-form-item__content{
            display: flex;
            flex-direction: row;
            align-items: center;
            .form-name-labelMobile{
              width: 56px;
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #676767;
              margin: 0 24px 0 0;
              flex-shrink: 0;
            }
            .el-input__inner{
              height: 30px;
              border-radius: 4px 4px 4px 4px;
              opacity: 1;
              border: 1px solid #DEE3EC;
            }
          }
        }
      }
    }
  }
  &-foot {
    padding: 15px 20px 25px;
    background: rgba(255, 255, 255, 0.95);
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: calc(100vw - 20px * 2);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    button{
      border:none;
    }

    &-resBtn {
      width: 76px;
      height: 38px;
      border-radius: 3px;
      opacity: 1;
      background-color: #FFFFFF;
      border: 1px solid #F08C2B !important;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #F08C2B;
      text-align: center;
      margin: 0 12px 0 0;
    }

    &-subBtn {
      width: 239px;
      height: 40px;
      background: #F08C2B;
      border-radius: 3px;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 40px;
      text-align: center;
    }
  }
}

</style>
<style lang="less" scoped>
.realnameCertificationMobile {
  background-image: none;
  background-color: var(--bg-page, #F7F5F2);

  &-head {
    color: var(--text-main, #111827);
    position: relative;

    .logo {
      position: absolute;
      top: 84px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
      width: 139px;
      height: 33px;
      box-sizing: border-box;
      padding: 4px 10px;
      border-radius: 4px;
      background-color: var(--bg-card, #FFFFFF);
      background-image: url("~@/assets/logo/logo_horizontal.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-size: calc(100% - 20px) calc(100% - 8px);
    }
  }

  &-body {
    &-card {
      background: var(--bg-card, #FFFFFF);
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

      &-form {
        .uploader {
          /deep/ .el-upload {
            background: var(--bg-section, #F7F5F2);
            border-color: var(--border-soft, #E8E4DE);
          }
        }
      }
    }
  }

  &-foot {
    border-top: 1px solid var(--border-soft, #E8E4DE);

    &-resBtn {
      color: var(--text-main, #1A1D24);
      border-color: var(--bg-dark, #1A1D24) !important;
      background: transparent;
    }

    &-subBtn {
      background: var(--primary, #FF5A1F);
      color: #FFFFFF;
    }
  }
}
</style>
